<template>

  <m-pay-generic-viewer
    title="My Merchant"
    :bean="merchant"
    :beanProperties="viewableMerchantProperties"
    :beanLabels="merchantLabels"
    :statusClasses="merchantStatusClasses"
    :formatters="{ createdDate: formatDate }"
  />

</template>

<script>
import MPayGenericViewer from '../MPayGenericViewer';
import { merchantStatusClasses } from '../../utils/statuses';

export default {
  name: 'MPayMerchantLimitedView',
  props: {
    merchant: { required: true },
  },
  components: { MPayGenericViewer },
  data: () => ({
    loading: false,
    merchantStatusClasses,
    viewableMerchantProperties: [
      'name',
      'legalId',
      'status',
      'iban',
      'responsiblePerson',
      'phone',
      'email',
      'country',
      'mccCode',
      'merchantId',
      'id',
      'createdDate',
    ],
    merchantLabels: [
      'Name',
      'Legal ID',
      'Status',
      'IBAN',
      'Responsible Person',
      'Phone',
      'Email',
      'Country',
      'MCC Code',
      'Merchant ID',
      'Financing Point of Sales ID',
      'ID',
      'Created Date',
    ],
  }),
  methods: {
    formatDate(timestamp) {
      if (timestamp) {
        return `${timestamp.substring(0, 10)} ${timestamp.substring(11, 16)}`;
      }
      return timestamp;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/merchant/MPayMerchantLimitedView.vue